
    import __i18nConfig from '@next-translate-root/i18n.json'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import Image from 'next/image';
import Link from 'next/link';
import useLocale from 'next-translate/useTranslation';
import React from 'react';
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css';
import CallToAction from '@/components/CallToAction';
import FaqTranscription from '@/components/FaqTranscription';
import FeaturedLogos from '@/components/FeaturedLogos';
import Footer from '@/components/layout/Footer';
import LandingPageNavigation from '@/components/layout/LandingPageNavigation';
import ButtonLink from '@/components/links/ButtonLink';
import LogosCloud from '@/components/LogosCloud';
import SecurityCompliance from '@/components/SecurityCompliance';
import Seo from '@/components/Seo';
import SupportedFormats from '@/components/SupportedFormats';
import Testimonials from '@/components/Testimonials';
import ThreeStepsProcess from '@/components/ThreeStepsProcess';
import TranscriptionFeaturesSimple from '@/components/TranscriptionFeaturesSimple';
import TranscriptionStats from '@/components/TranscriptionStats';
const Templates = () => {
    const { t, lang } = useLocale('ai-transcription');
    return (<main className='relative bg-gray-100 dark:bg-slate-900'>
      {/* <Banner /> */}
      <Seo templateTitle={t(lang === 'en'
            ? 'Best AI Audio Transcription Software | Speaker Detection, Summarization, Speech to Text'
            : 'Best AI Audio Transcription Software | Speaker Detection, Summarization, Speach to Text')} description={t('Join us and experience the power of state-of-the-art AI technology. Speaker detection, multilingual, and marvelously versatile.')} image={`https://easy-peasy.ai/api/og-template?title=${t('10x Audio Content With AI')}`}/>
      <div className='relative isolate overflow-hidden bg-white dark:bg-slate-900'>
        <div className='mx-auto'>
          <div className='relative z-10 pb-8 lg:w-full'>
            {/* Pink / Indigo modern dot pattern */}
            <div className='absolute inset-0 -z-10 bg-[radial-gradient(#80808033_1px,transparent_1px)] bg-[size:20px_20px] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_0%,#000_70%,transparent_100%)]'></div>

            <div className='absolute left-1/2 top-0 -z-10 -translate-x-1/2 transform-gpu blur-3xl' aria-hidden='true'>
              <div className='aspect-[1108/632] w-[69.25rem] bg-gradient-to-tr from-slate-200 to-indigo-100 dark:from-slate-800 dark:to-slate-700 opacity-40 dark:opacity-20' style={{
            clipPath: 'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
        }}/>
            </div>

            <div className='relative'>
              <div className='mx-auto'>
                <LandingPageNavigation />
                <main className='mx-auto mt-16 flex justify-center px-4 sm:mt-24 lg:px-8 pb-32 sm:pb-40'>
                  <div className='text-center max-w-4xl'>
                    <div className='mx-auto mb-8 sm:mt-8 flex justify-center'>
                      <div className='relative inline-flex items-center space-x-2 rounded-full px-4 py-1.5 text-sm font-medium leading-6 text-gray-600 dark:text-slate-300 ring-1 ring-gray-900/10 dark:ring-white/10 hover:ring-gray-900/20 dark:hover:ring-white/20 transition-all'>
                        <span className='flex h-2 w-2 rounded-full bg-primary-500'></span>
                        <span>{t('All-In-One AI Platform')}</span>
                      </div>
                    </div>

                    <h1 className='text-5xl font-extrabold tracking-tight text-gray-900 dark:text-white sm:text-7xl mb-8'>
                      {t('10x Audio Content ')}
                      <br className='hidden sm:block'/>
                      <span>{t('With AI')}</span>
                    </h1>

                    <p className='mx-auto max-w-2xl text-lg sm:text-xl leading-8 text-gray-600 dark:text-slate-300 mb-10 text-balance'>
                      {t('Turn long form audio into ready to use content assets, instantly.')}
                    </p>

                    <div className='mt-10 flex flex-col items-center justify-center gap-y-8'>
                      <div className='flex items-center gap-x-6'>
                        <ButtonLink href='/login?preset=audios' variant='dark' className='group relative overflow-hidden rounded-full shadow-lg hover:scale-105 transition-all duration-200 px-8 py-4'>
                          <span className='relative flex items-center gap-2 font-semibold text-lg'>
                            {t('Get started for free')}
                            <svg className='h-5 w-5 transition-transform group-hover:translate-x-1' fill='none' viewBox='0 0 24 24' strokeWidth='2' stroke='currentColor'>
                              <path strokeLinecap='round' strokeLinejoin='round' d='M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3'/>
                            </svg>
                          </span>
                        </ButtonLink>
                      </div>

                      <div className='flex flex-col items-center gap-4'>
                        <div className='flex -space-x-4 overflow-hidden py-1 px-3'>
                          {[
            '/images/ankita.png',
            '/images/dmytro.jpg',
            '/images/marianna_ole.jpeg',
            '/images/andrea.webp',
            '/images/cody.jpeg',
        ].map((src, i) => (<Image key={i} src={src} alt='User' width={40} height={40} className='inline-block h-10 w-10 rounded-full border-2 border-white dark:border-slate-900 ring-2 ring-gray-900/5 dark:ring-white/5'/>))}
                        </div>
                        <div className='flex flex-col items-center gap-1'>
                          <div className='flex gap-1'>
                            {[1, 2, 3, 4, 5].map((i) => (<svg key={i} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' fill='currentColor' className='h-5 w-5 text-yellow-400'>
                                <path d='M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z'></path>
                              </svg>))}
                          </div>
                          <p className='text-sm font-medium text-gray-600 dark:text-slate-400'>
                            <strong className='text-gray-900 dark:text-white'>
                              876,388+
                            </strong>{' '}
                            {t('happy users')}
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className='mt-16 flex flex-wrap justify-center gap-4 text-sm font-medium text-gray-600 dark:text-slate-400'>
                      <span className='inline-flex items-center gap-2 rounded-full bg-gray-50 dark:bg-white/5 px-4 py-2 ring-1 ring-inset ring-gray-200 dark:ring-white/10'>
                        🚀 {t('Powered by best AI models')}
                      </span>
                      <span className='inline-flex items-center gap-2 rounded-full bg-gray-50 dark:bg-white/5 px-4 py-2 ring-1 ring-inset ring-gray-200 dark:ring-white/10'>
                        🌍 {t('Supports 40+ languages')}
                      </span>
                      <span className='inline-flex items-center gap-2 rounded-full bg-gray-50 dark:bg-white/5 px-4 py-2 ring-1 ring-inset ring-gray-200 dark:ring-white/10'>
                        💳 {t('No credit card required')}
                      </span>
                    </div>
                  </div>
                </main>
              </div>
            </div>
          </div>
        </div>
      </div>
      <LogosCloud />

      {/* Add the new three steps process */}
      <ThreeStepsProcess />

      <div className='py-24 sm:py-32 lg:pb-40'>
        <div className='mx-auto max-w-7xl px-6 text-center lg:px-8'>
          <h2 className='mx-auto mt-2  max-w-3xl bg-gradient-to-r from-purple-600 via-red-500 to-primary-600 bg-clip-text text-center text-3xl font-bold tracking-tight text-transparent  sm:text-4xl'>
            {t('Manage Less, Create More.')}
            <br />
            {t('Grow Your Business With Content.')}
          </h2>
          <p className='mx-auto mt-5 max-w-prose text-xl text-gray-500 dark:text-slate-400'>
            {t('For professionals & creators who take content seriously.')}
          </p>
          <div className='mt-16 flow-root'>
            <div className='-m-2 rounded-xl bg-gray-900/5 p-2 ring-1 ring-inset ring-gray-900/10 lg:-m-4 lg:rounded-2xl lg:p-4'>
              <Image src='/images/transcription2.png' alt='AI Transcription' width={2432} height={1442} className='rounded-md shadow-2xl ring-1 ring-gray-900/10'/>
            </div>
          </div>
          <h2 className='mx-auto mt-20  max-w-3xl bg-gradient-to-r from-purple-600 via-red-500 to-primary-600 bg-clip-text text-center text-3xl font-bold tracking-tight text-transparent  sm:text-4xl'>
            {t('Highest Quality AI')}
            <br />
            {t('Based On Your Context')}
          </h2>
          <p className='mx-auto mt-5 max-w-2xl text-xl text-gray-500 dark:text-slate-400'>
            {t("Transcribe your content, and leverage world class AI to write quality drafts based on your recording's unique context.")}
          </p>
          <div className='mt-16 flow-root'>
            <div className='-m-2 rounded-xl bg-gray-900/5 p-2 ring-1 ring-inset ring-gray-900/10 lg:-m-4 lg:rounded-2xl lg:p-4'>
              <Image src='/images/transcription-chatgpt.png' alt='AI Chat with Transcription' width={2432} height={1442} className='rounded-md shadow-2xl ring-1 ring-gray-900/10'/>
            </div>
          </div>
          <h2 className='mx-auto mt-20  max-w-3xl bg-gradient-to-r from-purple-600 via-red-500 to-primary-600 bg-clip-text text-center text-3xl font-bold tracking-tight text-transparent  sm:text-4xl'>
            {t('Turn 1 Media File Into 100 Content Assets')}
          </h2>
          <p className='mx-auto mt-5 max-w-2xl text-xl text-gray-500 dark:text-slate-400'>
            {t('Automate all the tedious work that comes in editing & copywriting and say hello to your new best content editor.')}
          </p>
          <div className='mt-10 sm:flex sm:justify-center'>
            <div className='rounded-md shadow'>
              <ButtonLink href='/login?preset=audios' variant='dark' className='flex w-full items-center justify-center rounded-md border border-transparent bg-primary-600 px-8 py-3 text-base font-medium text-white hover:bg-primary-700 md:px-10 md:py-4 md:text-lg'>
                {t('Get started for free')}
              </ButtonLink>
            </div>
          </div>
          <div className='mt-10'>
            <h2 className='mx-auto mt-20 max-w-3xl bg-gradient-to-r from-purple-600 via-red-500 to-primary-600 bg-clip-text text-center text-3xl font-bold tracking-tight text-transparent sm:text-4xl'>
              {t('Explore Our AI Transcription Services')}
            </h2>
            <div className='mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3'>
              <Link href='/ai-transcription/podcast' className='group relative rounded-3xl bg-white dark:bg-slate-800/80 p-8 shadow-sm ring-1 ring-gray-900/5 dark:ring-white/10 hover:-translate-y-1 hover:shadow-xl hover:ring-primary-500/30 transition-all duration-300'>
                <h3 className='text-xl font-bold text-gray-900 dark:text-white group-hover:text-primary-600 dark:group-hover:text-primary-400 transition-colors'>
                  {t('Podcast')}
                </h3>
                <p className='mt-2 text-gray-600 dark:text-slate-300'>
                  {t('Transcribe your podcast episodes with high accuracy.')}
                </p>
                <span className='absolute inset-0' aria-hidden='true'/>
              </Link>
              <Link href='/ai-transcription/youtube' className='group relative rounded-3xl bg-white dark:bg-slate-800/80 p-8 shadow-sm ring-1 ring-gray-900/5 dark:ring-white/10 hover:-translate-y-1 hover:shadow-xl hover:ring-primary-500/30 transition-all duration-300'>
                <h3 className='text-xl font-bold text-gray-900 dark:text-white group-hover:text-primary-600 dark:group-hover:text-primary-400 transition-colors'>
                  {t('Youtube')}
                </h3>
                <p className='mt-2 text-gray-600 dark:text-slate-300'>
                  {t('Transcribe your YouTube videos with high accuracy.')}
                </p>
                <span className='absolute inset-0' aria-hidden='true'/>
              </Link>
              <Link href='/ai-transcription/lecture' className='group relative rounded-3xl bg-white dark:bg-slate-800/80 p-8 shadow-sm ring-1 ring-gray-900/5 dark:ring-white/10 hover:-translate-y-1 hover:shadow-xl hover:ring-primary-500/30 transition-all duration-300'>
                <h3 className='text-xl font-bold text-gray-900 dark:text-white group-hover:text-primary-600 dark:group-hover:text-primary-400 transition-colors'>
                  {t('Lecture')}
                </h3>
                <p className='mt-2 text-gray-600 dark:text-slate-300'>
                  {t('Get precise transcriptions of your lectures.')}
                </p>
                <span className='absolute inset-0' aria-hidden='true'/>
              </Link>
              <div className='group relative rounded-3xl bg-white dark:bg-slate-800/80 p-8 shadow-sm ring-1 ring-gray-900/5 dark:ring-white/10 hover:-translate-y-1 hover:shadow-xl hover:ring-primary-500/30 transition-all duration-300'>
                <h3 className='text-xl font-bold text-gray-900 dark:text-white group-hover:text-primary-600 dark:group-hover:text-primary-400 transition-colors'>
                  {t('Coaching Session')}
                </h3>
                <p className='mt-2 text-gray-600 dark:text-slate-300'>
                  {t('Transcribe your coaching sessions effortlessly.')}
                </p>
              </div>
              <div className='group relative rounded-3xl bg-white dark:bg-slate-800/80 p-8 shadow-sm ring-1 ring-gray-900/5 dark:ring-white/10 hover:-translate-y-1 hover:shadow-xl hover:ring-primary-500/30 transition-all duration-300'>
                <h3 className='text-xl font-bold text-gray-900 dark:text-white group-hover:text-primary-600 dark:group-hover:text-primary-400 transition-colors'>
                  {t('Sales Call')}
                </h3>
                <p className='mt-2 text-gray-600 dark:text-slate-300'>
                  {t('Accurately transcribe your sales calls.')}
                </p>
              </div>
              <Link href='/ai-transcription/meeting' className='group relative rounded-3xl bg-white dark:bg-slate-800/80 p-8 shadow-sm ring-1 ring-gray-900/5 dark:ring-white/10 hover:-translate-y-1 hover:shadow-xl hover:ring-primary-500/30 transition-all duration-300'>
                <h3 className='text-xl font-bold text-gray-900 dark:text-white group-hover:text-primary-600 dark:group-hover:text-primary-400 transition-colors'>
                  {t('Meeting')}
                </h3>
                <p className='mt-2 text-gray-600 dark:text-slate-300'>
                  {t('Transcribe your meetings with ease.')}
                </p>
                <span className='absolute inset-0' aria-hidden='true'/>
              </Link>
              <div className='group relative rounded-3xl bg-white dark:bg-slate-800/80 p-8 shadow-sm ring-1 ring-gray-900/5 dark:ring-white/10 hover:-translate-y-1 hover:shadow-xl hover:ring-primary-500/30 transition-all duration-300'>
                <h3 className='text-xl font-bold text-gray-900 dark:text-white group-hover:text-primary-600 dark:group-hover:text-primary-400 transition-colors'>
                  {t('Phone Call')}
                </h3>
                <p className='mt-2 text-gray-600 dark:text-slate-300'>
                  {t('Get accurate transcriptions of your phone calls.')}
                </p>
              </div>
              <div className='group relative rounded-3xl bg-white dark:bg-slate-800/80 p-8 shadow-sm ring-1 ring-gray-900/5 dark:ring-white/10 hover:-translate-y-1 hover:shadow-xl hover:ring-primary-500/30 transition-all duration-300'>
                <h3 className='text-xl font-bold text-gray-900 dark:text-white group-hover:text-primary-600 dark:group-hover:text-primary-400 transition-colors'>
                  {t('Webinar')}
                </h3>
                <p className='mt-2 text-gray-600 dark:text-slate-300'>
                  {t('Transcribe your webinars with high accuracy.')}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Add the new stats section */}
      <TranscriptionStats />

      {/* Add the supported formats section */}
      <SupportedFormats />

      <TranscriptionFeaturesSimple />

      {/* Add the security compliance section */}
      <SecurityCompliance />

      <FeaturedLogos />
      <FaqTranscription />
      <Testimonials />
      {/* <ContactUs /> */}
      <CallToAction preset='audios'/>
      <Footer />
    </main>);
};
export default Templates;
// add static props
async function getStaticProps() {
    return {
        props: {},
    };
}

    async function __Next_Translate__getStaticProps__1a0cbfb65ee__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/ai-transcription/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../../../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a0cbfb65ee__ as getStaticProps }
  